<div class="loader_section_block">
    <section class="loader_section">
      <div class="medium_regular_font d-flex flex-column align-items-center">
        <img loading="lazy"  src="assets/images/tsb_loader.gif" alt="loading">
      </div>
    </section>
  </div>
  